import styled from "styled-components";

const AlarmContainer = styled.div``;

const AlarmHeader = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 9px 13px;
  text-align: center;
  border-bottom: 1px solid #f1f3f5;

  h2 {
    color: #222529;
    font-weight: 700;
    font-size: 18px;
  }

  img {
    position: absolute;
    left: 13px;
    cursor: pointer;
  }
`;

const AlarmContent = styled.ul`
  li {
    padding: 16px;
    border-bottom: 1px solid #f1f3f5;

    .alarm-title-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .alarm-title {
        font-weight: 400;
        font-size: 12px;
        color: #ff7a00;
      }

      img {
        cursor: pointer;
      }
    }

    .alarm-content {
      font-weight: 400;
      font-size: 14px;
      color: #222529;
      margin-top: 8px;
    }

    .alarm-time {
      font-weight: 400;
      font-size: 12px;
      color: #878e95;
      margin-top: 8px;
    }
  }

  .already-read-alarm {
    background-color: #fff8f0;
    .alarm-title {
      font-weight: 600 !important;
    }
  }
`;

export { AlarmContainer, AlarmHeader, AlarmContent };
